import cloneDeep from 'lodash.clonedeep';

import { defaultFontLabel, defaultFontValue } from 'js/shared/resources/scribedefaults';
import { ExistingScribeModel, VSCFontAssetData } from 'js/types';

export default function checkScribeFonts(activeScribe: ExistingScribeModel, userFonts: Array<VSCFontAssetData>) {
  const userFontIds = userFonts.reduce((acc: Array<number>, current: VSCFontAssetData) => {
    return [...acc, current.projectAssetId];
  }, []);

  const newActiveScribe = cloneDeep(activeScribe);

  newActiveScribe.elements.forEach(element => {
    if (element.type === 'Text' && element.font?.assetId && !userFontIds.includes(element.font.assetId)) {
      element.font = {
        label: defaultFontLabel,
        value: defaultFontValue
      };
    }
  });

  return newActiveScribe;
}
